import { getDisplayName } from './getDisplayName';
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */

export function wrapDisplayName(Component, hocName) {
  return "".concat(hocName, "(").concat(getDisplayName(Component), ")");
}